import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Grid, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

function ReporteCortez() {
  const dispatch = useDispatch();
  const { user } = useSelector(state => state.auth);
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [filtroTexto, setFiltroTexto] = useState("");
  const [filtroTienda, setFiltroTienda] = useState("");
  const [filtroSerie, setFiltroSerie] = useState("");
  const [tiendas, setTiendas] = useState([]);
  const [series, setSeries] = useState([]);
  const [datosAPI, setDatosAPI] = useState(null);

  const tiendasPrecargadas = [
    { id: 1, nombre: 'TZ10' },
    { id: 2, nombre: 'TPRR' },
    { id: 3, nombre: 'TSCR' },
    { id: 4, nombre: 'TCSV' },
    { id: 5, nombre: 'TMIR' },
    { id: 6, nombre: 'TXLA' }
  ];

  useEffect(() => {
    setTiendas(tiendasPrecargadas);
  }, []);

  useEffect(() => {
    const nombreUsuario = user.usuario;
    const tiendasFiltradas = tiendasPrecargadas.filter(tienda =>
      tienda.nombre.includes(nombreUsuario)
    );

    if (tiendasFiltradas.length > 0) {
      setTiendas(tiendasFiltradas);
      setFiltroTienda(tiendasFiltradas[0].nombre);
    } else {
      setTiendas(tiendasPrecargadas);
      setFiltroTienda("");
    }
  }, [user]);

  // Actualizar las series disponibles según la tienda seleccionada
  useEffect(() => {
    if (datosAPI && filtroTienda) {
      const seriesDeTienda = datosAPI
        .filter(item => item.Establecimiento === filtroTienda)
        .map(item => item.Series);
      
      const seriesUnicas = [...new Set(seriesDeTienda)];
      setSeries(seriesUnicas);
      setFiltroSerie(""); // Resetear el filtro de serie al cambiar de tienda
    } else if (datosAPI) {
      const todasLasSeries = [...new Set(datosAPI.map(item => item.Series))];
      setSeries(todasLasSeries);
    }
  }, [datosAPI, filtroTienda]);

  const fetchData = () => {
    const datos = {
      Token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
      Ambiente: "DESA",
      Dispositivo: {
        Marca: "SAMSUNG",
        Modelo: "S22002B",
        Version: "Android 18.125",
        McAdress: null,
        PowerStatus: "84%",
        WifiStatus: "Conected to iphone de Mauricio",
        GPSStatus: "ON",
        GPS: "321|-485|321"
      },
      Usr: {
        Codigo: "1234",
        UserNickName: user.usuario
      },
      DatosMetodo: {
        NombreMetodo: "ListaReportesSalas",
        Datos_Recibidos: `{"Vista":"ReporteCierres", "FechaIni":"${fechaInicio}","FechaFin":"${fechaFin}"}`
      }
    };

    const fetchDataUrl = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(datos))}`;

    fetch(fetchDataUrl)
      .then(response => response.json())
      .then(data => {
        if (data && data.datos_Generados) {
          try {
            const datosGeneradosLimpiados = data.datos_Generados.replace(/\\\\"/g, '"').replace(/\\\\/g, '\\');
            const datosGeneradosDecodificados = JSON.parse(datosGeneradosLimpiados); 
            console.log(datosGeneradosDecodificados);
            setDatosAPI(datosGeneradosDecodificados);
          } catch (error) {
            console.error("Error al decodificar los datos generados:", error);
          }
        } else {
          console.error("No se recibieron datos generados válidos:", data);
        }
      })
      .catch(error => console.error('Error:', error));
  };

  const handleSearch = () => {
    fetchData();
  };

  const datosFiltrados = datosAPI
    ? datosAPI.filter(row => {
        const cumpleTienda = filtroTienda === "" || row.Establecimiento === filtroTienda;
        const cumpleSerie = filtroSerie === "" || row.Series === filtroSerie;
        return cumpleTienda && cumpleSerie;
      })
    : [];

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(datosFiltrados);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte Cortez");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: 'application/octet-stream' });

    saveAs(data, 'ReporteCortez.xlsx');
  };

  const exportToPDF = () => {
    const doc = new jsPDF();

    doc.autoTable({
      head: [['Fecha', 'Tienda', 'Serie', 'EFECTIVO','CHEQUES','CREDOMATIC','CUPON','Degustaciones','EMPLEADOS','EXENCION_IVA','NEO_NET_POS','NEO_NET_LINK','PEDIDOS_YA','TIENDA_EN_LINEA_Shopify','TRANSFERENCIA','TRANSFER_DM','VISA_NET','CUPON_DM','TOTAL']],
      body: datosFiltrados.map(row => [
        new Date(row.DocDate).toLocaleDateString(),
        row.Establecimiento,
        row.Series,
        row.EFECTIVO,
        row.CHEQUES,
        row.CREDOMATIC,
        row.CUPON,
        row.DEGUSTACIONES,
        row.EMPLEADOS,
        row.EXENCION_DE_IVA,
        row.NEO_NET_POS,
        row.NEO_NET_LINK,
        row.PEDIDOS_YA,
        row.TIENDA_EN_LINEA_Shopify,
        row.TRANSFERENCIA,
        row.TRANSFER_DM,
        row.VISA_NET,
        row.CUPON_DM,
        ((row.EFECTIVO|| 0 ) + (row.CHEQUES|| 0 ) + (row.CREDOMATIC|| 0 ) + (row.CUPON|| 0 ) + (row.DEGUSTACIONES|| 0 ) + (row.EMPLEADOS|| 0 ) + (row.EXENCION_DE_IVA|| 0 ) + (row.NEO_NET_POS|| 0 ) + (row.NEO_NET_LINK|| 0 ) + (row.PEDIDOS_YA|| 0 ) + (row.TIENDA_EN_LINEA_Shopify|| 0 ) + (row.TRANSFERENCIA|| 0 ) + (row.TRANSFER_DM|| 0 ) + (row.VISA_NET|| 0 ) + (row.CUPON_DM|| 0 ))
      ]),
    });

    doc.save('ReporteCortez.pdf');
  };

  return (
    <Container>
      <h2>Corte Z</h2>
      <hr />
      <Grid container spacing={2} alignItems="center" direction="row" wrap="nowrap">
        <Grid item xs={2}>
          <TextField
            label="Buscar"
            value={filtroTexto}
            onChange={(e) => setFiltroTexto(e.target.value)}
            fullWidth
          />
        </Grid>
        <Grid item xs={2}>
          <FormControl fullWidth>
            <InputLabel id="tienda-select-label">Tienda</InputLabel>
            <Select
              labelId="tienda-select-label"
              value={filtroTienda}
              onChange={(e) => setFiltroTienda(e.target.value)}
            >
              <MenuItem value="">Todas las tiendas</MenuItem>
              {tiendas.map((tienda) => (
                <MenuItem key={tienda.id} value={tienda.nombre}>
                  {tienda.nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={2}>
          <FormControl fullWidth>
            <InputLabel id="serie-select-label">Serie</InputLabel>
            <Select
              labelId="serie-select-label"
              value={filtroSerie}
              onChange={(e) => setFiltroSerie(e.target.value)}
              disabled={!datosAPI || series.length === 0}
            >
              <MenuItem value="">Todas las series</MenuItem>
              {series.map((serie, index) => (
                <MenuItem key={index} value={serie}>
                  {serie}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={2}>
          <TextField
            label="Fecha Inicio"
            type="date"
            value={fechaInicio}
            onChange={(e) => setFechaInicio(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            label="Fecha Fin"
            type="date"
            value={fechaFin}
            onChange={(e) => setFechaFin(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={1}>
          <Button variant="contained" color="primary" onClick={handleSearch} fullWidth>
            Buscar
          </Button>
        </Grid>
        <Grid item xs={1}>
          <Button variant="contained" color="warning" onClick={exportToPDF} fullWidth>
            PDF
          </Button>
        </Grid>
        <Grid item xs={1}>
          <Button variant="contained" color="success" onClick={exportToExcel} fullWidth>
            Excel
          </Button>
        </Grid>
      </Grid>

      <div style={{ marginTop: '20px' }}>
        {datosFiltrados.length > 0 && (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Fecha</TableCell>
                  <TableCell>Tienda</TableCell>
                  <TableCell>Serie</TableCell>
                  <TableCell>Efectivo</TableCell>
                  <TableCell>Cheques</TableCell>
                  <TableCell>Credomatic</TableCell>
                  <TableCell>Cupon</TableCell>
                  <TableCell>Degustaciones</TableCell>
                  <TableCell>EMPLEADOS</TableCell>
                  <TableCell>EXENCION_IVA</TableCell>
                  <TableCell>DOM_NEONET</TableCell>
                  <TableCell>PAGO_EN_LINEA</TableCell>
                  <TableCell>PEDIDOS_YA</TableCell>
                  <TableCell>TIENDA_EN_LINEA</TableCell>
                  <TableCell>TRANSFERENCIA</TableCell>
                  <TableCell>DOM_TRANSFERENCIA</TableCell>
                  <TableCell>VISANET</TableCell>
                  <TableCell>DOM_CUPON</TableCell>
                  <TableCell>Total </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {datosFiltrados.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{new Date(row.DocDate).toLocaleDateString()}</TableCell>
                    <TableCell>{row.Establecimiento}</TableCell>
                    <TableCell>{row.Series}</TableCell>
                    <TableCell>{row.EFECTIVO}</TableCell>
                    <TableCell>{row.CHEQUES}</TableCell>
                    <TableCell>{row.CREDOMATIC}</TableCell>
                    <TableCell>{row.CUPON}</TableCell>
                    <TableCell>{row.DEGUSTACIONES}</TableCell>
                    <TableCell>{row.EMPLEADOS}</TableCell>
                    <TableCell>{row.EXENCION_DE_IVA}</TableCell>
                    <TableCell>{row.NEO_NET_POS}</TableCell>
                    <TableCell>{row.NEO_NET_LINK}</TableCell>
                    <TableCell>{row.PEDIDOS_YA}</TableCell>
                    <TableCell>{row.TIENDA_EN_LINEA_Shopify}</TableCell>
                    <TableCell>{row.TRANSFERENCIA}</TableCell>
                    <TableCell>{row.TRANSFER_DM}</TableCell>
                    <TableCell>{row.VISA_NET}</TableCell>
                    <TableCell>{row.CUPON_DM}</TableCell>
                    <TableCell>{((row.EFECTIVO|| 0 ) + (row.CHEQUES|| 0 ) + (row.CREDOMATIC|| 0 ) + (row.CUPON|| 0 ) + (row.DEGUSTACIONES|| 0 ) + (row.EMPLEADOS|| 0 ) + (row.EXENCION_DE_IVA|| 0 ) + (row.NEO_NET_POS|| 0 ) + (row.NEO_NET_LINK|| 0 ) + (row.PEDIDOS_YA|| 0 ) + (row.TIENDA_EN_LINEA_Shopify|| 0 ) + (row.TRANSFERENCIA|| 0 ) + (row.TRANSFER_DM|| 0 ) + (row.VISA_NET|| 0 ) + (row.CUPON_DM|| 0 ))}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>
    </Container>
  );
}

export default ReporteCortez;